import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {get_Payment_History,get_UserData} from '../../../store/actions/CommanAction';
import DataTable from 'react-data-table-component';
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';
import Loader from '../Loader/Loader';
import Select from "react-select";
import { customStyles } from "../Utility/Utility";


const PaymentHistory = () => {
    const dispatch = useDispatch();

    const Paymenthistory = useSelector((state) => state.feedBackReducer.PaymentHistory);
    const userData = useSelector((state) => state.feedBackReducer.UserData);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [orderStatus, setOrderStatus] = useState(null);
    const [loading, setloading] = useState(false);
    const [selectedAstro, setSelectedAstro] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;

        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;

        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);
        // dispatch(get_Payment_History(formattedToday, formattedToday,orderStatus,isActive,setloading));
        dispatch(get_Payment_History(formattedToday, formattedToday,selectedAstro.value,setloading));
    }, [dispatch]);


    const handleSearch = (isActive) => {

        const formatDate = (dateTime) => {
            if (!dateTime) return null;
            const date = new Date(dateTime);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };

        const formattedStartDate = formatDate(startTime);
        const formattedEndDate = formatDate(endTime);

        const data = {
            FromDate: formattedStartDate,
            Todate: formattedEndDate,
            orderStatus: orderStatus,
        };

        dispatch(get_Payment_History(data.FromDate, data.Todate,selectedAstro.value,setloading));


    };
    useEffect(()=>{
        dispatch(get_UserData(setloading,isActive))
    },[])

    useEffect(() => {
        if (userData && Array.isArray(userData)) {
            const filtered = userData.map(({ NickName, UserID }) => ({
                label: NickName,
                value: UserID,
            }));
            setFilteredData(filtered);
        }
    }, [userData]);


    const columns = [
        {
            name: 'User Name', selector: (row) => row.UserName, sortable: true,
        },
       
        {
            name: 'payment Amount', selector: (row) => row.payment_amount/100, sortable: true,
        },
        {
            name: 'Gst Amount', selector: (row) => row.GstAmt, sortable: true,
        },

        {
            name: 'Payment Status', selector: (row) => row.payment_status, sortable: true,
        },

    ];
    return (
        <div>

            <div className="form-group main_card">
                <div className="row mt-3">
                    <div className="col-3">
                        <label className="form-label">Start Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">End Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">Search by User Name</label>
                        <Select
                            options={filteredData}
                            value={selectedAstro}
                            onChange={(selectedOption) => setSelectedAstro(selectedOption)}
                            placeholder="Select user"
                            isSearchable
                        
                        />
                    </div>
                </div>

              

                <button className="btn btn-primary mt-3"   onClick={() => handleSearch(isActive)}>
                    Search
                </button>

            </div>


            <div className="col-12 mt-2 main_card">
                {loading ? (
                    <Loader />
                ) : (
                    <DataTable
                        dense
                        data={Paymenthistory || []}
                        columns={columns}
                        selectableRowsHighlight
                        pagination
                         customStyles={customStyles}
                        persistTableHead={true}
                        noDataComponent={"There are no data to display"}
                    />)}
            </div>
        </div>
    );
};
export default PaymentHistory;



